import { Info } from '@mui/icons-material';
import { Dialog, DialogActions, Typography } from '@mui/material';
import { CompanyDocumentResell } from 'lib/api/reSell/factoring/types';
import CustomButton from 'lib/designSystem/Button';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import React from 'react';

import { useFactoringResell } from '../../context';

const RegisterSelector: React.FC = () => {
  const {
    openRegisterSelector,
    setOpenRegisterSelector,
    setOpenMultiPayment,
    setOpenMultiSales,
    setOpenMultiBuyBack,
    resells,
    selectedResellIds,
    setResellsSelected,
  } = useFactoringResell();

  const getResellsSelected = () => {
    const resellsSelected = resells.filter((resell: CompanyDocumentResell) =>
      selectedResellIds.includes(resell.id),
    );
    const mappedResells = resellsSelected.map(
      (resell: CompanyDocumentResell) => ({
        ...resell,
        suggestedAmountPayment: Math.max(
          resell.amount - resell.documentAmountConciliated,
          0,
        ),
        suggestedAmountBuyback: resell.documentAmountRemaining,
      }),
    );
    return mappedResells;
  };

  const handleMultiPayment = () => {
    const resellsSelected = getResellsSelected();
    setResellsSelected(resellsSelected);
    setOpenMultiPayment(true);
    setOpenRegisterSelector(false);
  };

  const handleMultiBuyBack = () => {
    const resellsSelected = getResellsSelected();
    setResellsSelected(resellsSelected);
    setOpenMultiBuyBack(true);
    setOpenRegisterSelector(false);
  };

  const handleCreateResell = () => {
    setOpenMultiSales(true);
    setOpenRegisterSelector(false);
  };

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open={openRegisterSelector}
      onClose={() => setOpenRegisterSelector(false)}
    >
      <div style={{ padding: 20, minHeight: 200 }}>
        <div>
          <HeaderWithActions title="Qué necesitas registrar?" />
          <div style={{ textAlign: 'center' }}>
            <div
              style={{
                padding: '10px 0px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div>
                <CustomButton
                  onClick={() => handleMultiPayment()}
                  color="primary"
                  disabled={selectedResellIds.length === 0}
                >
                  Registrar pagos
                </CustomButton>
              </div>
              <div>
                {selectedResellIds.length === 0 && (
                  <LightTooltip
                    title={
                      <Typography variant="body1" style={{ padding: 10 }}>
                        Selecciona al menos una venta
                      </Typography>
                    }
                  >
                    <Info sx={{ cursor: 'pointer' }} />
                  </LightTooltip>
                )}
              </div>
            </div>
            <div
              style={{
                padding: '10px 0px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div>
                <CustomButton
                  onClick={() => handleMultiBuyBack()}
                  color="primary"
                  disabled={selectedResellIds.length === 0}
                >
                  Recomprar facturas
                </CustomButton>
              </div>
              <div>
                {selectedResellIds.length === 0 && (
                  <LightTooltip
                    title={
                      <Typography variant="body1" style={{ padding: 10 }}>
                        Selecciona al menos una venta
                      </Typography>
                    }
                  >
                    <Info sx={{ cursor: 'pointer' }} />
                  </LightTooltip>
                )}
              </div>
            </div>
            <div style={{ padding: '10px 0px' }}>
              <CustomButton
                onClick={() => handleCreateResell()}
                color="primary"
              >
                Registrar venta
              </CustomButton>
            </div>
          </div>
        </div>
        <DialogActions>
          <CustomButton
            onClick={() => setOpenRegisterSelector(false)}
            color="secondary"
          >
            Salir
          </CustomButton>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default RegisterSelector;
